import loadable from "@loadable/component"
import type { SketchProps } from "./sketch"

export const LoadableSketch = loadable<SketchProps>(() =>
  import("./sketch").then(sketch => sketch.Sketch)
)
